import dynamic from 'next/dynamic';

import Wrapper from './Wrapper';
import Play from '../icons/Play';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

interface VideoProps {
  src: string;
  wrapperClassName?: string;
}

const Video = ({
  src,
  wrapperClassName,
}: VideoProps) => {
  return (
    <Wrapper className={wrapperClassName}>
      <ReactPlayer
        controls
        height="auto"
        light
        playIcon={<Play />}
        playing
        src={src}
        width="100%"
        wrapper="div"
      />
    </Wrapper>
  );
};

export default Video;
